<template>
  <teleport to="body">
    <div class="modal" v-if="open" @click.self.prevent="closeModal">
      <div class="wrapper">
        <font-awesome-icon icon="fa-xmark" class="exit" @click="closeModal" />
        <h3>Select categories to apply this modifier</h3>
        <div class="categories">
          <div v-for="category in categories" :key="category.id" class="checkbox-container">
            <input type="checkbox" :id="'category-' + category.id" :value="category.id" v-model="selectedCategories" ref="categoryCheckboxes" />
            <label :for="'category-' + category.id">{{ category.id.split(":")[1].split("-").join(" ") }}</label>
          </div>
        </div>
        <button v-if="!allSelected" @click="selectAll" class="select-all">Select all</button>
        <button v-if="allSelected" @click="deselectAll" class="select-all">Deselect all</button>
        <button class="btn" @click="update">Apply</button>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: "ApplyModal",
  props: ["open", "categories", "current"],
  emits: ["close", "update"],

  data() {
    return {
      selectedCategories: [],
      allSelected: false,
    };
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.checkIfChecked();
        });
      }
    },
  },

  methods: {
    checkIfChecked() {
      if (this.current && Array.isArray(this.current)) {
        this.selectedCategories = [...this.current];
      }
    },

    deselectAll() {
      this.selectedCategories = [];
      this.allSelected = false;
    },

    update() {
      this.$emit("update", this.selectedCategories);
      this.closeModal();
    },

    closeModal() {
      this.selectedCategories = [];
      this.$emit("close");
    },

    selectAll() {
      this.allSelected = true;
      this.$refs.categoryCheckboxes.forEach((checkbox) => {
        checkbox.checked = true;
        if (!this.selectedCategories.includes(checkbox.value)) {
          this.selectedCategories.push(checkbox.value);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.wrapper {
  background: var(--background-colour);
  padding: 1rem;
  border-radius: 0.5rem;
  box-shadow: var(--box-shadow);
  position: relative;
  width: 90%;
  max-width: 500px;
}

h3 {
  color: var(--text-colour);
  text-align: center;
  margin: 0.5rem;
}

.select-all {
  padding: 0.5rem 1rem;
  margin: 0.5rem;
  background: var(--primary-colour);
  color: var(--action-colour);
  cursor: pointer;
}

.categories {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem 1rem;
  padding: 0.5rem;
  width: calc(100% - 1rem);
  .checkbox-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0.25rem;
    padding: 0.5rem;
    background: var(--opacity-background);
    border-radius: 1rem;
    box-shadow: var(--box-shadow);

    input[type="checkbox"] {
      margin-right: 1rem;
      width: 1rem;
      height: 1rem;
      cursor: pointer;
      border: none;
    }

    label {
      color: var(--text-colour);
      font-size: 1rem;
      text-transform: capitalize;
      cursor: pointer;

    }
  }
}

.btn {
  background: var(--action-colour);
  color: var(--secondary-text-colour);
  padding: 0.5rem 1rem;
  margin: 0.5rem;
  cursor: pointer;
}
</style>
